import { useQuery } from '@tanstack/react-query'
import { billingApi } from '../../utils/api'

/**
 * お支払い履歴の取得（BillingPage のお支払い履歴セクション）。
 * queryKey: ['payment-history']
 */
export function usePaymentHistory() {
  return useQuery({
    queryKey: ['payment-history'],
    queryFn: () => billingApi.getHistory(),
  })
}
